import {
  getTableData,
  saveDetail,
  updateDetail,
  getDetail,
  updateStatus,
  getAnnounce
} from '@/axios/api/announcement'
import { Message } from 'element-ui'

const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const CLEAR_PARMS = 'CLEAR_PARMS'

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    title: undefined,
    createUserId: undefined,
    startTime: undefined,
    endTime: undefined,
    hidden: undefined,
    userId: undefined,
    roleId: undefined
  },
  detail: {}
}

const getters = {
  tableData: state => state.tableData,
  pager: state => state.pager,
  params: state => state.params,
  tblLoading: state => state.tblLoading,
  detailLoading: state => state.detailLoading,
  detail: state => state.detail
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, ...params }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [CLEAR_PARMS] (state) {
    state.params = {
      title: undefined,
      createUserId: undefined,
      startTime: undefined,
      endTime: undefined,
      hidden: undefined
    }
  }
}

const actions = {
  async getTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      const { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  setPagerApi ({commit}, params) {
    commit(UPDATE_PAGER, params)
  },
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  clearParamsApi ({ commit }) {
    commit(CLEAR_PARMS)
  },
  // saveDetail
  async saveDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      await saveDetail(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return true
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  async updateDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      await updateDetail(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return true
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const { data: res } = await getDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 更新状态
  async updateStatusApi ({ commit }, params) {
    try {
      await updateStatus(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 当登录或刷新页面时，获取公告信息
  async getAnnounceApi ({ commit }) {
    try {
      const { data: res } = await getAnnounce()
      return res || false
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/announcement.js